import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "bootstrap/dist/css/bootstrap.min.css";
import "@icon/icofont/icofont.css";

import i18n from "./i18n";
import { Store } from "redux";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { CookiesProvider } from "react-cookie";
import { I18nextProvider } from "react-i18next";

import IStore from "./models/IStore";
import rootStore from "./stores/rootStore";
import App from "./views/App";

import "./index.css";

(async (_window: Window): Promise<void> => {
  const initialState: Partial<IStore> = {};
  const store: Store<IStore> = rootStore(initialState);

  const rootEl: HTMLElement | null = document.getElementById("root");

  if (rootEl) {
    const root = createRoot(rootEl);
    root.render(
      <Provider store={store}>
        <CookiesProvider>
          <I18nextProvider i18n={i18n}>
            <App />
          </I18nextProvider>
        </CookiesProvider>
      </Provider>,
    );
  }
})(window);
